var map = {
	"./61_stretch.mp3": "763d",
	"./61_stretch_fantastic.mp3": "af1e",
	"./62_shake.mp3": "eacd",
	"./63_pat.mp3": "c483",
	"./63_pat_fantastic.mp3": "2b659",
	"./M_Think again.mp3": "0b59",
	"./M_Try again.mp3": "0bc0",
	"./M_Work harder.mp3": "0333"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37fc";